import { render } from "./Empty.vue?vue&type=template&id=56f61f88"
import script from "./Empty.vue?vue&type=script&lang=js"
export * from "./Empty.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./Empty.vue?vue&type=style&index=0&id=56f61f88&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script